// extracted by mini-css-extract-plugin
export default {"loader":"MagicTextLoader_loader__U4KJk","gradient-shift":"MagicTextLoader_gradient-shift__6Owjo"};